import { createApiClient, desktopTokenStore, isElectron, type TokenStore } from '@fluxter/shared';
import { localStorageTokenStore } from './token-store';

const baseUrl = import.meta.env.VITE_API_URL ?? 'http://127.0.0.1:8000';

/**
 * In the desktop shell, persist the bearer token through the Electron
 * main process where `safeStorage` encrypts it with the OS keychain. In
 * the browser, fall back to `localStorage` — there's no better option
 * inside a sandboxed renderer, and an attacker with localStorage access
 * already has script execution on our origin.
 *
 * Both stores conform to the same async-shaped `TokenStore` contract,
 * so consumers always `await` regardless of which one is wired in.
 */
const pickTokenStore = (): TokenStore => (isElectron() ? desktopTokenStore() : localStorageTokenStore());

export const tokenStore = pickTokenStore();

export const api = createApiClient({
  baseUrl,
  tokenStore,
  onUnauthorized: () => {
    if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
      window.location.assign('/login');
    }
  },
});
